module.exports = __webpack_public_path__ + "static/print-illus-0b9edefedc76f318fc75db17c348d531.svg";